import React from "react";
import theme from "@shared/utils/themeColors";

export interface MediaPreview {
  id: string;
  type: "image" | "video" | "gif";
  url: string;
  progress?: number;
  error?: string;
  message?: string;
}

interface MessageMediaPreviewProps {
  media: MediaPreview;
  onRemove: (id: string) => void;
}

const MessageMediaPreview: React.FC<MessageMediaPreviewProps> = ({
  media,
  onRemove,
}) => {
  const { type, url, progress, error } = media;

  return (
    <div className="relative w-24 h-24 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700 mr-2">
      {/* Preview */}
      {type === "image" || type === "gif" ? (
        <img src={url} alt="Preview" className="w-full h-full object-cover" />
      ) : (
        <video src={url} className="w-full h-full object-cover" />
      )}

      {/* Progress Overlay */}
      {typeof progress === "number" && progress < 100 && (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className={`w-12 h-12 rounded-full border-2 ${theme.border.brand} border-t-transparent animate-spin`} />
          <span className="absolute text-white text-sm">{progress}%</span>
        </div>
      )}

      {/* Error Overlay */}
      {error && (
        <div className={`absolute inset-0 ${theme.bg.error} bg-opacity-50 flex items-center justify-center`}>
          <span className="text-white text-xs text-center px-1">{error}</span>
        </div>
      )}

      {/* Remove Button */}
      <button
        className="absolute top-1 right-1 w-5 h-5 rounded-full bg-gray-900 bg-opacity-50 hover:bg-opacity-75 flex items-center justify-center"
        onClick={() => onRemove(media.id)}
      >
        <svg
          className="w-3 h-3 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
};

export default MessageMediaPreview;
